<template>
  <div class="movies-area pb-100">
    <div class="container mw-1356">
      <div
        class="section-title mw-690 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">{{ c.top_title }}</span>
        <h2 :class="className">{{ c.heading }}</h2>
      </div>
    </div>

    <div class="container-fluid p-0">
      <Swiper
        :slidesPerView="1"
        :spaceBetween="24"
        :centeredSlides="false"
        :preventClicks="true"
        :loop="true"
        :autoplay="{
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }"
        :breakpoints="{
          0: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          576: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
          1440: {
            slidesPerView: 6,
          },
        }"
        :modules="modules"
        class="movies-slide"
      >
        <SwiperSlide v-for="(slide, i) in effectiveSlides" :key="i">
          <RouterLink :to="c.cta_url || '/pricing'">
            <img :src="slide.image" alt="movie" />
          </RouterLink>
        </SwiperSlide>
      </Swiper>
    </div>

    <div class="text-center mt-4 pt-1">
      <p class="text-silver">{{ c.tagline }}</p>
      <RouterLink :to="c.cta_url || '/pricing'" class="btn">
        <span class="border-style">{{ c.cta_text }}</span>
      </RouterLink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";
import { useContent } from "@/composables/useContent";

/* eslint-disable @typescript-eslint/no-var-requires */
const defaultImages = [
  require("@/assets/images/movie-1.jpg"),
  require("@/assets/images/movie-2.jpg"),
  require("@/assets/images/movie-3.jpg"),
  require("@/assets/images/movie-4.jpg"),
  require("@/assets/images/movie-5.jpg"),
  require("@/assets/images/movie-6.jpg"),
];

const defaults = {
  top_title: "STREAM EVERYTHING",
  heading: "Beyond the World Cup — Movies, Series, Sports & More",
  tagline: "One subscription. Every sport, movie, series, and live event — all in one place.",
  cta_text: "Get World Cup Access",
  cta_url: "/pricing",
  slides: Array.from({ length: 12 }, () => ({ image_url: "" })),
};

export default defineComponent({
  name: "EnjoyYourTime",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["className"],
  setup() {
    const { content } = useContent("movies_slider", defaults);
    const c = computed(() => content.value);

    const effectiveSlides = computed(() => {
      const cms = (c.value.slides || [])
        .filter((s: { image_url?: string }) => s.image_url)
        .map((s: { image_url: string }) => ({ image: s.image_url }));
      return cms.length > 0
        ? cms
        : Array.from({ length: 12 }, (_, i) => ({ image: defaultImages[i % defaultImages.length] }));
    });

    return {
      c,
      effectiveSlides,
      modules: [Autoplay],
    };
  },
});
</script>
